import { ProdConfig } from './blocks/config/prod.config';

ProdConfig();



// WEBPACK FOOTER //
// ./src/app/app.main-aot.ts